import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";

import "../src/i18n/config";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
